import {
  handleSocketCreateMiscTransactionError,
  handleSocketCreateMiscTransactionSuccess,
} from './actions';

/**
 * Consumed by Socket context to register listeners
 */

const createMiscTransactionEvents = (dispatch, socket) => {
  socket.on('cmtx.error', (message) => {
    // Sanitize the error message to prevent React serialization issues
    const sanitizedMessage =
      typeof message === 'object' && message !== null
        ? {
            error:
              message.error ||
              message.text ||
              'An error occurred during misc transaction creation',
          }
        : { error: 'An error occurred during misc transaction creation' };
    dispatch(handleSocketCreateMiscTransactionError(sanitizedMessage));
  });

  socket.on('cmtx.success', (message) => {
    const { payload } = message;
    dispatch(handleSocketCreateMiscTransactionSuccess(payload));
  });
};

export default createMiscTransactionEvents;
